import React from 'react';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import '../styles/Cart.css';

const Contact = () => {
  return (
    <div className="cart-page">
      <div className="cart-container">
        <div className="empty-cart">
          <div className="empty-cart-image" style={{ marginBottom: '20px' }}>
            <FiMail size={100} color="#ff3f6c" />
          </div>
          <h2>Need help? We are here!</h2>
          <p>You can reach out to us for any queries or support.</p>
          
          <div style={{ marginTop: '2rem', textAlign: 'left', background: '#f9f9f9', padding: '2rem', borderRadius: '8px', width: '100%', maxWidth: '500px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
              <FiMail size={24} color="#ff3f6c" style={{ marginRight: '1rem' }} />
              <div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>Email Us</h3>
                <p style={{ color: '#666' }}>support@kalingastore.shop</p>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
              <FiPhone size={24} color="#ff3f6c" style={{ marginRight: '1rem' }} />
              <div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>Call Us</h3>
                <p style={{ color: '#666' }}>+91 7217786935</p>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <FiMapPin size={24} color="#ff3f6c" style={{ marginRight: '1rem' }} />
              <div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.25rem' }}>Visit Us</h3>
                <p style={{ color: '#666' }}>12A,  Old Vijay Nagar, Ghaziabad, Uttar Pradesh - 201001</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
